export default "__VITE_ASSET__Cms33Ktg__"